export default {
  data() {
    return {};
  },

  created() {},

  methods: {}
};